import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-admission',
  templateUrl: './admission.component.html',
  styleUrls: ['./admission.component.scss']
})
export class AdmissionComponent implements OnInit {

  AdmissionForm: FormGroup;
  filteredDataList: any;
  DataList: any;
  dialogRef: MatDialogRef<any>;
  submitpayload: any;
  listdesc: any;
  submitButton = true;
  editButton = false;
  deleteButton = false;
  SessionNo: any;
  constructor(public umsService: UmsService,private spinner:NgxSpinnerService,
    private modalPopupService: ModalpopService,
    public fb: FormBuilder) { }

  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    this.submitButton = true;
    this.editButton = false;
    this.deleteButton = false;
    this.AdmissionForm = this.fb.group({
      AdmlistNo: new FormControl(),
      AdmlistNo2: new FormControl(),
      AdmlistNo3: new FormControl('New'),
      AdmClg: new FormControl(),
      AdmValid: new FormControl(),
      Adm: new FormControl(),
      AdmChng: new FormControl(),
      AdmRgNo: new FormControl(),
      AdmBranch: new FormControl(),
      AdmName: new FormControl(),
      AdmCate: new FormControl(),
      AdmOptSub: new FormControl(),
      AdmValid2: new FormControl(),
      AdmValid3: new FormControl(),
      AdmMod: new FormControl(),
     } );

    
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      }
    );
  }

  deletee(e, k){
    if (e === 'true'){
      
      this.prepopulationForDelete(k);
    } else {
      
    }
  }

  prepopulationForDelete(data){
    this.editButton = false;
    this.submitButton = false;
    this.deleteButton = true;
  }
 
  getExmFrmList(id){
    const payload = {};
    payload['InCode'] = id;
    payload['SnNo'] = this.SessionNo;
    payload['OpId'] = sessionStorage.getItem('userId');
    this.umsService.getExmFrmDrpList(payload).subscribe((res) => {
      if (res.status) {
        this.DataList = res.data;
        this.filteredDataList = this.DataList.slice();
       
      } else {
      }
    });
  }

  edit(k,id){
    if (k === 'true') {
      this.prepopulation(id);
    }
  }


  prepopulation(data){
    this.editButton = true;
    this.submitButton = false;
    this.deleteButton = false;
    
  }

  addnewrecord(e){
    if (e === 'true'){
      this.editButton = false;
      this.submitButton = true;
      this.deleteButton = false;
       this.AdmissionForm.reset();
    } 
    else {
      this.editButton = true;
      this.submitButton = false;
      this.deleteButton = true;
        this.ngOnInit();
    }
  }


  submit(){
    if (this.AdmissionForm.invalid) {
      
      return;
    } else {
      this.submitEnrollment();
    }
  }
  submitEnrollment() {
    this.submitpayload = this.AdmissionForm.value;
  }

  delete(){

  }

  update(){
    if (this.AdmissionForm.invalid) {
      
      return;
    } else {
      this.updateEnrollment();
    }
  }

  updateEnrollment(){

  }

}
